import { Card, Container, Grid, Skeleton, createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  newsLetter: {
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      width: "222.6px",
      left: "40.5%",
      top: "-45px",
      height: "83px",
      backgroundImage: `url(/images/horizantalTexture.png)`,
      backgroundRepeat: "no-repeat",
      zIndex: 10,
    },
    "&:after": {
      content: '""',
      position: "absolute",
      right: "30px",
      width: "20%",
      transform: " translate(97%, -130%)",
      height: "222.6px",
      backgroundImage: `url(/images/verticalTexture.png)`,
      backgroundRepeat: "no-repeat",
      zIndex: 10,
      [theme.fn.smallerThan("md")]: {
        display: "none",
      },
    },
  },
}));

export default function NewsletterSkeleton() {
  const { classes } = useStyles();

  return (
    <Container
      className={`my-[95px] bg-brandGrey rounded-[34px] pt-[60px] px-2 md:ps-2 mx-4 xl:mx-auto ${classes.newsLetter}`}>
      <Grid>
        <Grid.Col
          span={12}
          md={5}
          className='p-0 md:pb-0'
          orderLg={1}
          orderMd={1}
          orderSm={2}
          orderXs={2}>
          <Grid className='px-6 md:ps-6'>
            {Array.from(Array(4)).map((item, index) => (
              <Grid.Col sm={12} md={12} lg={6} key={index}>
                <Card
                  padding={"md"}
                  style={{ borderRadius: "12px" }}
                  withBorder>
                  <Skeleton height={70} width={40} className='rounded-full' />
                  <div className='flex mt-1'>
                    <div className='flex flex-col ms-[12px]'>
                      <Skeleton height={20} width={120} className='mb-2' />
                      <Skeleton height={16} width={120} />
                    </div>
                  </div>
                </Card>
              </Grid.Col>
            ))}
          </Grid>
        </Grid.Col>
        <Grid.Col
          span={12}
          md={7}
          orderLg={2}
          orderMd={2}
          orderSm={1}
          orderXs={1}
          className='lg:ps-[70px] flex flex-col justify-around mb-8 px-4'>
          <div>
            <Skeleton height={30} width={96} className='mb-2' radius={"xl"} />
            <Skeleton height={70} width={200} className='mb-2' radius={"xl"} />
            <Skeleton height={20} width={300} className='mb-1' radius={"xl"} />
            <Skeleton height={20} width={300} className='mb-1' radius={"xl"} />
            <Skeleton height={20} width={300} className='mb-3' radius={"xl"} />
          </div>

          <Skeleton
            height={60}
            className='mb-3 w-full md:w-[75%]'
            radius={"md"}
          />
        </Grid.Col>
      </Grid>
    </Container>
  );
}
